import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import LandingPage from './LandingPage';
import Simulator from './Simulator';
import ManageProducts from './ManageProducts';
import EtfDetail from './EtfDetail';
import EtfCompare from './EtfCompare';
import OAuthCallback from './OAuthCallback';
import { SiteSettings } from './Layout';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <SiteSettings />
        <Routes>
          <Route path="/"          element={<LandingPage />} />
          <Route path="/simulator" element={<Simulator />} />
          <Route path="/manage"    element={<ManageProducts />} />
          <Route path="/etf/:id"   element={<EtfDetail />} />
          <Route path="/compare"   element={<EtfCompare />} />
          <Route path="/callback"  element={<OAuthCallback />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
